import { render, staticRenderFns } from "./search_bar.vue?vue&type=template&id=87597832&scoped=true"
import script from "./search_bar.vue?vue&type=script&lang=js"
export * from "./search_bar.vue?vue&type=script&lang=js"
import style0 from "./search_bar.vue?vue&type=style&index=0&id=87597832&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87597832",
  null
  
)

export default component.exports